import { render } from "./StepBenchmarkWithFollowup.vue?vue&type=template&id=273fe646&scoped=true"
import script from "./StepBenchmarkWithFollowup.vue?vue&type=script&lang=js"
export * from "./StepBenchmarkWithFollowup.vue?vue&type=script&lang=js"

import "./StepBenchmarkWithFollowup.vue?vue&type=style&index=0&id=273fe646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273fe646"]])

export default __exports__